"use client"
import React, { ReactNode, useEffect, useState } from "react"
import Image from "next/image"
import { Pages } from "@/Enums/pages"

import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline"
import { HeartIcon } from "@heroicons/react/24/solid"
import Link from "next/link"

const Topbar: React.FC = () => {
  const [Page, setPage] = useState(Pages.HOME)

  const [NavOpen, setNavOpen] = useState(false)

  useEffect(() => {
    const currentPath = window.location.pathname
    if (currentPath === "/") {
      setPage(Pages.HOME)
    } else if (currentPath.endsWith(Pages.ABOUT)) {
      setPage(Pages.ABOUT)
    } else if (currentPath.endsWith(Pages.CONTACT)) {
      setPage(Pages.CONTACT)
    } else if (currentPath.endsWith(Pages.ANKIETA)) {
      setPage(Pages.ANKIETA)
    } else {
      setPage(Pages.MORE)
    }
  }, [])

  return (
    <div className='h-40 transition-all duration-100 z-999'>
      <header
        className={`mx-auto fixed top-0 flex justify-around max-lg:justify-between items-center py-20 px-20 bg-main transition-all duration-100 text-white5 w-full h-36 ${
          NavOpen ? "nav-open" : ""
        }`}>
        <Link
          href='/'
          className='w-24 flex items-center justify-center select-none'>
          <Image
            src='/Logo.svg'
            alt='Logo Szkolny Przewodnik'
            width={500}
            height={500}
            className='w-full h-full z-20 '
          />
        </Link>
        <nav className='max-lg:hidden ol-container flex items-center gap-4 '>
          <ol className='gap-10 w-auto mr-5 flex list-none'>
            <ListItem
              text={"Strona Główna"}
              href='/'
              active={Page === Pages.HOME}
            />
            <ListItem
              text={"O nas"}
              href={"/" + Pages.ABOUT}
              active={Page === Pages.ABOUT}
            />

            <ListItem
              text={"Szkolne >"}
              active={Page === Pages.MORE}
              className='group'>
              <ul className='group-hover:opacity-100 opacity-0 fixed top-[116%] left-1/2 -translate-x-1/2 bg-[rgba(40,40,95,0.8)] p-5 rounded-xl border-[rgb(40,40,95)] shadow-[0_10px_60px_#2c2c55] transition-all duration-300 border-[3px]'>
                {[
                  ["Kalkulator", "/app/kalkulator"],
                  ["Doradztwo", "/app/doradztwo"],
                  ["Nawigator", "/app/nawigator"],
                  ["Kalendarz", "/app/kalendarz"],
                  ["Rekrutacja", "/app/rekrutacja"],
                  ["Testy", "/app/testy"],
                ].map((el, index) => (
                  <li
                    className='relative text-center text-[1.8rem] mt-4 first:mt-0 hover:scale-110 transition-all select-none'
                    key={index}>
                    <Link href={el[1] as string}>{el[0]}</Link>
                  </li>
                ))}
              </ul>
            </ListItem>
            <ListItem
              text={"Ankieta"}
              href={"/" + Pages.ANKIETA}
              active={Page === Pages.ANKIETA}
            />
            <ListItem
              text={"Kontakt"}
              href={"/" + Pages.CONTACT}
              active={Page === Pages.CONTACT}
            />
          </ol>
          <Link
            href='https://pomagam.pl/szkolny-przewodnik'
            target='_blank'
            rel='noopener noreferrer'
            className='group relative select-none inline-flex items-center justify-center rounded-full px-6 py-2 text-3xl font-semibold tracking-tight text-white bg-[linear-gradient(180deg,#3b8cff_0%,#2d6bd5_52%,#1e4bb8_100%)] hover:brightness-110 hover:-translate-y-[1px] active:translate-y-[0] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#4ca1ff]/70 focus-visible:ring-offset-2 focus-visible:ring-offset-main transition-all duration-300 ease-out overflow-hidden'>
            <span className='pointer-events-none absolute top-0 left-1/2 -translate-x-1/2 w-[80%] h-[55%] rounded-full bg-white/20 blur-md opacity-60 group-hover:opacity-80'></span>
            <HeartIcon className='w-6 h-6 mr-3 text-white/90 transition-transform duration-300 group-hover:scale-125 group-hover:rotate-12 relative z-10' aria-hidden='true' />
            <span className='relative z-10'>Wesprzyj nas</span>
          </Link>
        </nav>

        <button
          className='z-50 hidden max-lg:block outline-none hover:scale-110'
          aria-label={NavOpen ? "Zamknij menu" : "Otwórz menu"}
          onClick={() => {
            setNavOpen(!NavOpen)
          }}>
          <Bars3Icon
            className={`hamburger-icon-menu size-10 max-lg:size-20 ${
              NavOpen ? "hidden" : ""
            }`}
          />
          <XMarkIcon
            className={`hamburger-icon-close size-10 max-lg:size-20 ${
              NavOpen ? "" : "hidden"
            }`}
          />
        </button>
        <div
          className={`bg-[rgba(28,28,60,0.514)] backdrop-blur-md fixed top-0 left-0 w-full overflow-hidden  flex items-center justify-center gap-24 transition-all duration-500 ease-in select-none  ${
            NavOpen
              ? " opacity-100 pointer-events-auto visible translate-y-[0] h-screen"
              : "h-0 opacity-0 pointer-events-none invisible -translate-y-full"
          }`}>
          <div className='flex flex-col items-center justify-center gap-5'>
            <nav className='flex items-center gap-4'>
              <ol className=' gap-9 w-auto mr-5 flex list-none flex-col'>
                <ListItem
                  text={"Strona Główna"}
                  href='/'
                  active={Page === Pages.HOME}
                  className='text-6xl mb-4'
                />
                <ListItem
                  text={"O nas"}
                  href={"/" + Pages.ABOUT}
                  active={Page === Pages.ABOUT}
                  className='text-6xl mb-4'
                />
                <ListItem
                  text={"Ankieta"}
                  href={"/" + Pages.ANKIETA}
                  active={Page === Pages.ANKIETA}
                  className='text-6xl mb-4'
                />
                <ListItem
                  text={"Kontakt"}
                  href={"/" + Pages.CONTACT}
                  active={Page === Pages.CONTACT}
                  className='text-6xl mb-8'
                />
                <li className='flex justify-center'>
                  <Link
                    href='https://pomagam.pl/szkolny-przewodnik'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='group relative select-none inline-flex items-center justify-center rounded-full px-8 py-4 text-4xl font-semibold tracking-tight text-white bg-[linear-gradient(180deg,#3b8cff_0%,#2d6bd5_52%,#1e4bb8_100%)] hover:brightness-110 hover:-translate-y-[2px] active:translate-y-[0] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#4ca1ff]/70 focus-visible:ring-offset-2 focus-visible:ring-offset-main transition-all duration-300 ease-out overflow-hidden'>
                    <span className='pointer-events-none absolute top-0 left-1/2 -translate-x-1/2 w-[80%] h-[55%] rounded-full bg-white/20 blur-md opacity-60 group-hover:opacity-80'></span>
                    <HeartIcon className='w-8 h-8 mr-4 text-white/90 transition-transform duration-300 group-hover:scale-125 group-hover:rotate-12 relative z-10' aria-hidden='true' />
                    <span className='relative z-10'>Wesprzyj nas</span>
                  </Link>
                </li>
              </ol>
            </nav>
          </div>
          <ul className='bg-[rgb(40,40,95,0.8)] p-8 rounded-2xl border-[rgba(40,40,95)] border-[3px] shadow-lg shadow-black'>
            <li className='text-center transition-all duration-200 select-none text-5xl mb-8 hover:scale-125'>
              <Link href={"/app/kalkulator"}>Kalkulator</Link>
            </li>
            <li className='text-center transition-all duration-200 select-none text-5xl mb-8 hover:scale-125'>
              <Link href={"/app/doradztwo"}>Doradztwo</Link>
            </li>
            <li className='text-center transition-all duration-200 select-none text-5xl mb-8 hover:scale-125'>
              <Link href={"/app/nawigator"}>Nawigator</Link>
            </li>
            <li className='text-center transition-all duration-200 select-none text-5xl mb-8 hover:scale-125'>
              <Link href={"/app/kalendarz"}>Kalendarz</Link>
            </li>
            <li className='text-center transition-all duration-200 select-none text-5xl mb-8 hover:scale-125'>
              <Link href={"/app/rekrutacja"}>Rekrutacja</Link>
            </li>
            <li className='text-center transition-all duration-200 select-none text-5xl hover:scale-125'>
              <Link href={"/app/testy"}>Testy</Link>
            </li>
          </ul>
        </div>
      </header>
    </div>
  )
}
export default Topbar

const ListItem: React.FC<{
  text: string
  active: boolean
  href?: string
  className?: string
  children?: ReactNode
}> = ({ text, href = "/", active, children, className }) => {
  return (
    <li
      className={`mb-1 text-center text-5xl relative font-bold transition-all duration-300 cursor-pointer hover:scale-[1.2] hover:skew-y-[0.5deg] select-none ${
        active
          ? "after:content-[''] after:bg-[#55a3fc66] after:shadow after:shadow-[#55a3fc66] after:w-[90%] after:h-[6px] after:rounded-md after:absolute after:left-2/4 after:bottom-[-5px] after:translate-x-[-50%]"
          : ""
      } ${className}`}>
      {children ? (
        <>
          {text}
          {children}
        </>
      ) : (
        <Link href={href} className='tracking-tighter'>
          {text}
        </Link>
      )}
    </li>
  )
}
